// Общий потолок ожидания fetch: залипшая мобильная сеть / VPN держит запрос
// минутами без reject → вечные скелетоны на auth.me и tRPC.
//
// Если вызывающий уже передал `signal` — не трогаем (отмена остаётся у него).

/** Дефолт для обычных tRPC queries/mutations (батч). */
export const DEFAULT_FETCH_TIMEOUT_MS = 15_000;

/** Cold-start auth.me — короче: есть persist-кэш, ждать дольше бессмысленно. */
export const AUTH_ME_TIMEOUT_MS = 8_000;

export function withFetchTimeout(init: RequestInit | undefined, timeoutMs: number): RequestInit {
	if (init?.signal) return init;
	if (typeof AbortSignal !== "undefined" && "timeout" in AbortSignal) {
		return { ...init, signal: AbortSignal.timeout(timeoutMs) };
	}
	return init ?? {};
}

/** Abort/timeout от AbortSignal.timeout — то же, что сетевой сбой для UI. */
export function isAbortOrTimeoutError(err: unknown): boolean {
	if (err instanceof DOMException) {
		return err.name === "AbortError" || err.name === "TimeoutError";
	}
	if (err instanceof Error) {
		return err.name === "AbortError" || err.name === "TimeoutError";
	}
	return false;
}
